<template>

    <div>

            <!--热门-->
    </div>
</template>


<script>
    export default{

        data () {
            return {
                    msg: 'Welcome to Your Vue.js App'
            }
        }
    }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Hot.vue